import { render } from "./bidangPenataanLH.vue?vue&type=template&id=10eda7c4"
import script from "./bidangPenataanLH.vue?vue&type=script&lang=js"
export * from "./bidangPenataanLH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__